import { CheckMovement } from "../map/Movement";
import { Point } from "../../engine/space/bounds";
import { Directions, getDirectionTowards } from "../../engine/space/directions";
import { Actor } from "../actors/Actor";
import { findActorForPosition, gameData } from "../GameManager";
import { GibManager } from "../anims/particleSystem";
import { HitParticle } from "../anims/particles/HitParticle";
import {
  damageWithForce,
  getActorArmor,
  getDamageReduction,
  reduceDamage,
} from "../items/formulas";
import {
  attackMsg,
  blockFailMsg,
  blockMsg,
  blockSuccMsg,
} from "../messages/AttackMessages";
import { getActiveAttack } from "../actors/weaponHelper";

export const attackTo = (actor: Actor, options: { target: Point }) => {
  const dir = getDirectionTowards(actor, options.target);
  return attackTowards(actor, { dir });
};

export const attackTowards = async (
  actor: Actor,
  options: { dir: Directions }
) => {
  const tile =
    gameData.current.tiles[actor.x + actor.y * gameData.current.width];
  let x = actor.x;
  let y = actor.y;
  if (!CheckMovement[options.dir](tile)) {
    return { valid: false };
  }
  switch (options.dir) {
    case Directions.Up:
      y -= 1;
      break;
    case Directions.Right:
      x += 1;
      break;
    case Directions.Down:
      y += 1;
      break;
    case Directions.Left:
      x -= 1;
      break;
  }
  const target = findActorForPosition(x, y);
  if (target) {
    const attack = getActiveAttack(actor);

    await GibManager.runThenDestroy(HitParticle, x, y);
    const dmgReduction = getDamageReduction(getActorArmor(target));
    const rawDamage = damageWithForce(
      attack.damage || 1,
      actor.attributes.force || 0
    );
    if (target.status.blocking) {
      const shieldAttack = getActiveAttack(target);
      if (shieldAttack && shieldAttack.blocks) {
        const postShieldDamage = reduceDamage(
          rawDamage,
          1 - shieldAttack.blocks
        );
        const rawStaminaDamage = attack.stamina || 0;
        const staminaDamage = reduceDamage(
          rawStaminaDamage,
          1 - (shieldAttack.stability || 0) / 100
        );
        const tCurStamina = actor.stamina.current;
        const oSpillover = staminaDamage - tCurStamina;
        const dSpillover =
          2 * (shieldAttack.stability || 0) - (rawDamage + rawStaminaDamage);

        const attackDamage = reduceDamage(postShieldDamage, dmgReduction);
        blockMsg(actor, target, attackDamage);
        //If not enough sta to cover, take remainder as poise damage + attack poise damage
        if (0 < oSpillover) {
          target.poise.change(-1 * (oSpillover + (attack.poise || 0)));
          blockFailMsg(target);
          //If shield can cover, deal poise damage back to target
        } else if (0 < dSpillover) {
          blockSuccMsg(actor);
          actor.poise.change(-1 * dSpillover);
          actor.status.hit = true;
        }
        target.stamina.change(-1 * staminaDamage);
        target.health.change(-1 * attackDamage);
      } else {
        console.warn("blocked attack without a blocking attack.");
      }
    } else {
      const attackDamage = reduceDamage(rawDamage, dmgReduction);
      target.health.change(-1 * attackDamage);
      target.poise.change(-1 * (attack.poise || 0));
      attackMsg(actor, target, attackDamage);
    }
    actor.stamina.change(-1 * attack.stamina);
    target.status.hit = true;
    return { valid: true };
  }

  return { valid: true };
};

export const blockAttacks = (actor: Actor) => {
  actor.status.blocking = true;
  return { valid: true };
};
